import { sprintf } from 'sprintf-js';

import { H5 } from 'components/Text/H5';

import { useCmsReactionsContext } from './CmsReactionsContext';

export function CmsTotalReactionsHeading() {
  const { totalReactions } = useCmsReactionsContext();

  if (totalReactions === 0) return null;

  let headingText: string = '';

  if (totalReactions === 1) {
    headingText = sprintf(getText('%(totalReactions)s Idealist reacted'), {
      totalReactions,
    });
  }

  if (totalReactions > 1) {
    headingText = sprintf(getText('%(totalReactions)s Idealists reacted'), {
      totalReactions,
    });
  }

  return (
    <H5 marginBottom={0} marginTop={0}>
      {headingText}
    </H5>
  );
}
